module.exports = __webpack_public_path__ + "static/media/choithramsOffersG.44d5faf8.png";